import useTranslate from "hooks/useTranslate";
import { LoyaltyGetRewardCard } from "../../molecules/LoyaltyGetRewardCard";
import { LoyaltyRewardHelp } from "../../molecules/LoyaltyRewardHelp";
import { LOYALTY_GET_REWARD_CARD_LIST } from "../../../constants/loyalty";
import "./styles.sass";

export const LoyaltyGetRewards = () => {
  const t = useTranslate();
  const redirectUl = "rules";

  return (
    <div className="LoyaltyGetRewards">
      <h2 className="LoyaltyGetRewards__header">
        {t("loyalty.redesign.1.how.get.title")}
      </h2>
      <div className="LoyaltyGetRewards__cards">
        {LOYALTY_GET_REWARD_CARD_LIST.map((card) => {
          return <LoyaltyGetRewardCard key={card.id} card={card} />;
        })}
      </div>
      <LoyaltyRewardHelp
        text="loyalty.redesign.1.reward.help"
        bntText="loyalty.redesign.1.reward.help.btn"
        background="var(--brandColor)"
        redirectUrl={redirectUl}
      />
    </div>
  );
};
